import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";

@Component({
  selector: "ab-restricted-warning-alert",
  templateUrl: "./restricted-warning.component.html",
})
export class RestrictedWarningAlertComponent implements OnInit {
  public show: boolean;

  constructor(private accountService: AccountService) {}

  public close() {
    this.show = false;
  }

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts ? props.alerts.restricted_alert === true : false;
    });
  }
}
